import { useState, useEffect } from 'react'
import NeighborsProjects from './NeighborsProjects'
import Image from './Image'
import {useParams} from "react-router-dom";
import Detail from "./projet-components/Detail";

function Projet(){
    const [donnees, setDonnees] = useState(null)
    const { project } = useParams()

    useEffect(() => {
        fetch('/donnees.json',
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            })
            .then(response => response.json())
            .then(result => {
                const idx = Object.keys(result.projects).indexOf(project)
                const res = result.projects[project]
                res.left = Object.keys(result.projects)[idx-1]
                res.right = Object.keys(result.projects)[idx+1]
                setDonnees(res)
            })
    },[project]);

    if(!donnees){        
        return <div className={"projet-conteneur"}></div>
    }
    else{
        const titre = <h2 className={"projet-titre"}>{donnees['titre']}</h2>
        const client = donnees['client'] && <Detail titre={"client"} valeur={donnees['client']}/>
        const annees = donnees['année'] && <Detail titre={"année"} valeur={donnees['année']}/>
        const categorie = donnees['catégorie'] && <Detail titre={"catégorie"} valeur={donnees['catégorie']}/>
        const paragraph = <p className={"projet-paragraph texte-regular"}>{donnees['commentaire']}</p>

        const images = donnees.photos.map((value,key)=>{
            return(<div className={"conteneur-photo projet"} key={key}>
                <Image src={value} alt={value}/>
            </div>)
        })

        return (<div className={"projet-conteneur"}>
            <div className={"projet-wrap"}>
                {titre}
                {client}
                {categorie}
                {annees}
                {paragraph}
                <NeighborsProjects left={donnees.left} right={donnees.right}/>
            </div>
            <div className={"panneau right projet"}>
                <div head className={"texte-thin projet-wrap head"}>
                    {titre}
                    {client}
                    {categorie}
                    {annees}
                    {paragraph}
                    <NeighborsProjects left={donnees.left} right={donnees.right}/>
                </div>
                {images}
            </div>
        </div>)
    }    
}

export default Projet
